import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  EventMessage,
  AuthenticationResult,
  EventType,
} from "@azure/msal-browser";
import "./index.css";
import "./i18n";
import InterviewSessions from "./pages/InterviewSessions";
import LoginPage from "./components/auth/LoginPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { Toaster } from "sonner";
import { MSALAuthProvider, msalInstance } from "./AuthProvider";
import { debugError } from "./utils/debug";

// Handle initialization and redirect
(async () => {
  await msalInstance.initialize();

  // Handle redirect promise after login
  await msalInstance.handleRedirectPromise().catch((error) => {
    debugError("Redirect promise error:", error);
  });

  // Listen for sign-in events
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
      const result = event.payload as AuthenticationResult;
      msalInstance.setActiveAccount(result.account);
    }
  });

  // Default to using the first account if available
  if (msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Render the app after initialization
  renderApp();
})();

function renderApp() {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MSALAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <InterviewSessions />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </MSALAuthProvider>
    </React.StrictMode>
  );
}
